<div class="outline-surface-300 absolute inset-0 -z-10 outline-3" [class]="twRounded()"></div>

<p
  class="relative py-2 outline-3 transition-colors select-none"
  [class]="tw() + ' ' + twRounded()"
  (click)="isSelectable() ? toggleSelection() : undefined"
>
  {{ word() }}
</p>
